/**
 * Client-side error logging — same pattern as elsewhere in this repo (e.g. `SalesOrderDetailsSharedBL`: `console.error("[InvoiceLink]", error)`).
 */
export function logClientRuntimeError(scope, error) {
    console.error("[".concat(scope, "]"), error);
}
